// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'
export default createVuetify({
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#1976D2',
          secondary: '#424242',
          background: '#ffffff',
          surface: '#ffffff',
          'on-surface': '#090909ff',
        },
      },
      dark: {
        colors: {
          primary: '#1976D2',
          secondary: '#979696ff',
          background: '#989595ff',
          surface: '#262626ff',
          'on-surface': '#f5f3f3ff',
        },
      },
    },
  },
})